module.exports = __webpack_public_path__ + "static/media/blendingblue.cb9272e4.png";